/* Kling Ceramics: client-side facetfilter voor collectiepagina's.
   Werkt zonder Search & Discovery. Leest facet-data uit de product-kaarten
   (data-kling-finish / data-kling-size), bouwt checkbox-groepen in elke
   [data-facet-mount] (desktop filterkolom + mobiele sectie), filtert de
   kaarten client-side en houdt de selectie in de URL (kf_* params). */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function parsePipe(s) {
    return (s || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function parseCsv(s) {
    return (s || '').split(',').map(function (x) { return decodeURIComponent(x.trim()); }).filter(Boolean);
  }
  function sortByCount(map) {
    return Object.keys(map).map(function (k) { return { value: k, count: map[k] }; })
      .sort(function (a, b) { return b.count - a.count || a.value.localeCompare(b.value); });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  ready(function () {
    var grid = document.querySelector('.product-grid');
    var mounts = [].slice.call(document.querySelectorAll('[data-facet-mount]'));
    if (!grid || !mounts.length) return;
    var cards = [].slice.call(grid.querySelectorAll('.product-grid__item'));
    if (cards.length < 2) return;

    // Tel distincte facetwaarden over alle kaarten
    var finishCounts = {}, sizeCounts = {};
    cards.forEach(function (c) {
      parsePipe(c.getAttribute('data-kling-finish')).forEach(function (v) { finishCounts[v] = (finishCounts[v] || 0) + 1; });
      parsePipe(c.getAttribute('data-kling-size')).forEach(function (v) { sizeCounts[v] = (sizeCounts[v] || 0) + 1; });
    });

    // Een facet is alleen bruikbaar met 2..MAX distincte waarden. Tegels hebben >200
    // serie-specifieke kleurnamen (onbruikbaar als filter) -> die groep valt zo af,
    // terwijl afmeting (~20) en sanitair-afwerking (~19) wel getoond worden.
    var MAX = 40;
    function usable(map) { var n = Object.keys(map).length; return n >= 2 && n <= MAX; }

    var groups = [];
    if (usable(sizeCounts)) {
      groups.push({ key: 'size', param: 'kf_size', label: 'Afmeting', attr: 'data-kling-size', values: sortByCount(sizeCounts) });
    }
    if (usable(finishCounts)) {
      groups.push({ key: 'finish', param: 'kf_finish', label: 'Afwerking / kleur', attr: 'data-kling-finish', values: sortByCount(finishCounts) });
    }
    if (!groups.length) return;

    // Beginselectie uit de URL
    var params = new URLSearchParams(window.location.search);
    var state = {};
    groups.forEach(function (g) { state[g.key] = new Set(parseCsv(params.get(g.param))); });

    // UI opbouwen in elke mount
    // Mobiele mount standaard ingeklapt (anders duwen ~15 maatchips de producten onder de vouw),
    // tenzij er al een selectie actief is.
    mounts.forEach(function (mount) {
      var collapsed = mount.classList.contains('kling-facet-mount--mobile');
      mount.innerHTML = buildHtml(groups, state, collapsed);
    });

    // Events
    mounts.forEach(function (mount) {
      mount.addEventListener('change', function (e) {
        var cb = e.target.closest('input[data-facet-key]');
        if (!cb) return;
        var key = cb.getAttribute('data-facet-key');
        if (cb.checked) state[key].add(cb.value); else state[key].delete(cb.value);
        syncCheck(mounts, key, cb.value, cb.checked);
        applyAndRefresh();
      });
      mount.addEventListener('click', function (e) {
        var clr = e.target.closest('[data-facet-clear]');
        if (!clr) return;
        e.preventDefault();
        groups.forEach(function (g) { state[g.key].clear(); });
        mounts.forEach(function (m) { [].slice.call(m.querySelectorAll('input[data-facet-key]')).forEach(function (i) { i.checked = false; }); });
        applyAndRefresh();
      });
    });

    function applyAndRefresh() {
      apply(cards, groups, state);
      updateUrl(groups, state);
      updateCounts(mounts, groups, cards, state);
    }

    // Initiele toepassing (URL-selectie herstellen)
    mounts.forEach(function (mount) {
      groups.forEach(function (g) {
        state[g.key].forEach(function (v) {
          var sel = mount.querySelector('input[data-facet-key="' + g.key + '"][value="' + cssEscape(v) + '"]');
          if (sel) sel.checked = true;
        });
      });
    });
    applyAndRefresh();
  });

  function cssEscape(v) { return String(v).replace(/["\\]/g, '\\$&'); }

  function buildHtml(groups, state, collapsed) {
    var html = '';
    groups.forEach(function (g) {
      var open = !collapsed || state[g.key].size > 0;
      html += '<details class="facets__panel kling-facetgroup"' + (open ? ' open' : '') + '>';
      html += '<summary class="facets__summary"><span class="facets__label">' + esc(g.label) + '</span></summary>';
      html += '<div class="facets__inputs-wrapper"><ul class="kling-facet-list list-unstyled">';
      g.values.forEach(function (v) {
        var checked = state[g.key].has(v.value) ? ' checked' : '';
        html += '<li class="kling-facet-item"><label class="kling-facet-label">' +
          '<input type="checkbox" data-facet-key="' + g.key + '" value="' + esc(v.value) + '"' + checked + '>' +
          '<span class="kling-facet-name">' + esc(v.value) + '</span>' +
          '<span class="kling-facet-count">' + v.count + '</span>' +
          '</label></li>';
      });
      html += '</ul><button type="button" class="kling-facet-clear" data-facet-clear>Wissen</button></div>';
      html += '</details>';
    });
    return html;
  }

  function syncCheck(mounts, key, value, checked) {
    mounts.forEach(function (m) {
      [].slice.call(m.querySelectorAll('input[data-facet-key="' + key + '"]')).forEach(function (i) {
        if (i.value === value) i.checked = checked;
      });
    });
  }

  function apply(cards, groups, state) {
    cards.forEach(function (card) {
      var visible = groups.every(function (g) {
        if (state[g.key].size === 0) return true;
        var cardVals = (card.getAttribute(g.attr) || '').split('|');
        for (var i = 0; i < cardVals.length; i++) {
          if (state[g.key].has(cardVals[i].trim())) return true;
        }
        return false;
      });
      card.style.display = visible ? '' : 'none';
      card.toggleAttribute('data-kling-hidden', !visible);
    });
  }

  function updateUrl(groups, state) {
    if (!window.history || !window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    groups.forEach(function (g) {
      if (state[g.key].size) params.set(g.param, Array.from(state[g.key]).map(encodeURIComponent).join(','));
      else params.delete(g.param);
    });
    var qs = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
  }

  function updateCounts(mounts, groups, cards, state) {
    var anyActive = groups.some(function (g) { return state[g.key].size > 0; });
    var visible = cards.filter(function (c) { return c.style.display !== 'none'; }).length;

    // Eigen resultaatteller in elke mount
    mounts.forEach(function (mount) {
      var el = mount.querySelector('.kling-facet-total');
      if (!el) {
        el = document.createElement('div');
        el.className = 'kling-facet-total';
        mount.insertBefore(el, mount.firstChild);
      }
      el.textContent = anyActive ? (visible + ' van ' + cards.length + ' producten') : '';
      el.style.display = anyActive ? '' : 'none';
    });

    // Native "X artikelen" teller bijwerken (leaf-node eenmalig zoeken + cachen)
    try {
      if (updateCounts._node === undefined) {
        updateCounts._node = null;
        var scope = document.querySelector('.product-grid-container') || document;
        var nodes = scope.querySelectorAll('*');
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          if (n.children.length === 0 && /^\s*\d+\s*artikelen\s*$/i.test(n.textContent)) { updateCounts._node = n; break; }
        }
      }
      if (updateCounts._node) {
        updateCounts._node.textContent = (anyActive ? visible : cards.length) + ' artikelen';
      }
    } catch (e) {}
  }
})();
